
import 'chart.js/auto';
import { Chart as ChartJS } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { GetLineChartOptions, ChartPluginLegendMargin } from './_ChartUtils';
import type { ReactElement } from 'react';
import type { LineChartProps } from './_chart';
import annotationPlugin from 'chartjs-plugin-annotation';

ChartJS.register(annotationPlugin);

const LineChart = (props: LineChartProps): ReactElement | null => {
    const { chartData, expectedHeight, maxValue, annotation, xLabel, yLabel } = props;

    if (chartData) {
        const displayedGroupLabelCount = chartData.data ?
            chartData.data.datasets.filter(set => {
                return set.label && set.label !== '' && set.label !== 'hidden';
            }).length
            : 0;
        const optionToUse = GetLineChartOptions({
            maxValue,
            showFilterTitle: (displayedGroupLabelCount > 0),
            annotation,
            xLabel,
            yLabel,
        });

        const barMaxHeight = expectedHeight && !isNaN(expectedHeight) ? expectedHeight : 600;

        return (
            <Line
                height={barMaxHeight}
                options={optionToUse}
                data={chartData.data ? chartData.data : { datasets: [] }}
                plugins={[ChartPluginLegendMargin(24), annotationPlugin]}
                style={{ maxHeight: `${barMaxHeight}px` }}
            />
        );
    }

    return null;
};

export default LineChart;
